import { AdCommentPin } from "../../marketing-review-interfaces/marketing-review.interface";

export class ReviewAdModel {

    private commentId!: number;
    private commentedBy!: string;
    private piasRepCode!: string;
    private description!: string;
    private status!: string;
    private replyId!: number;
    private replyComment!: string;
    private pin!: AdCommentPin;
    private userRole!: string;
    private documentId!: number;
    private groupId!:number;

    constructor() { }


    // Getters & Setters
    getCommentId(): number {
        return this.commentId;
    }
    setCommentId(commentId: number) {
        this.commentId = commentId;
    }

    getCommentedBy(): string {
        return this.commentedBy;
    }

    setCommentedBy(commentedBy: string) {
        this.commentedBy = commentedBy;
    }

    getPiasRepCode(): string {
        return this.piasRepCode;
    }

    setPiasRepCode(piasRepCode: string) {
        this.piasRepCode = piasRepCode;
    }

    getDescription(): string {
        return this.description;
    }

    setDescription(description: string) {
        this.description = description;
    }

    getPin() {
        return this.pin;
    }

    setPin(data: AdCommentPin) {
        this.pin = data;
    }

    getReplyId(): number {
        return this.replyId;
    }
    setReplyId(replyId: number) {
        this.replyId = replyId;
    }

    getReplyComment(): string {
        return this.replyComment;
    }

    setReplyComment(replyComment: string) {
        this.replyComment = replyComment;
    }

    getStatus(): string {
        return this.status;
    }

    setStatus(status: string) {
        this.status = status;
    }

    getUserRole(): string {
        return this.userRole;
    }

    setUserRole(userRole: string) {
        this.userRole = userRole;
    }

    getDocumentId(): number {
        return this.documentId;
    }

    setDocumentId(documentId: number) {
        this.documentId = documentId;
    }

    getGroupId(): number {
        return this.groupId;
    }

    setGroupId(groupId: number) {
        this.groupId = groupId;
    }

    toString() {
        return JSON.stringify({
            commentedBy: this.getCommentedBy(),
            piasRepCode: this.getPiasRepCode(),
            description: this.getDescription(),
            status: this.getStatus(),
            replyId: this.getReplyId(),
            replyComment: this.getReplyComment(),
            userRole: this.getUserRole(),
            pin: this.getPin(),
            documentId: this.getDocumentId(),
            group_id:this.getGroupId(),
        });
    }

    updatetoString() {
        return JSON.stringify({
            commentId: this.getCommentId(),
            commentedBy: this.getCommentedBy(),
            piasRepCode: this.getPiasRepCode(),
            description: this.getDescription(),
            status: this.getStatus(),
            replyId: this.getReplyId(),
            replyComment: this.getReplyComment(),
            userRole: this.getUserRole(),
            pin: this.getPin(),
            documentId: this.getDocumentId(),
            group_id:this.getGroupId(),
        });
    }
}
